export default __webpack_public_path__ + "static/media/Class_of_1954.cb29ca65.jpg";